import { QueryKey, useSuspenseQuery, UseSuspenseQueryOptions } from '@tanstack/react-query';

import { queryClient } from '@/config/queryClient';

import { getRequest } from './requests/get';
import { RequestData } from './types';

export const useApiGetSuspenseRequest = <PathVariables, QueryParams, SuccessResponse, ErrorResponse = Error>(
  queryKey: QueryKey,
  path: string,
  params?: RequestData<PathVariables, QueryParams, undefined>,
  options?: Omit<UseSuspenseQueryOptions<SuccessResponse, ErrorResponse>, 'queryKey' | 'queryFn'>,
) => {
  const abort = () => {
    queryClient.cancelQueries({ queryKey });
  };

  const query = useSuspenseQuery<SuccessResponse, ErrorResponse>({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey,
    queryFn: ({ signal }) => getRequest<SuccessResponse>(path, params?.pathVariables, params?.queryParams, signal),
    ...options,
  });

  return {
    abort,
    ...query,
  };
};
